module.exports = __webpack_public_path__ + "static/img/14000797.640d2f4d.png";